import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { clsx } from "./auth-service-tools193.js";
import { createPolymorphicComponent } from "./auth-service-tools245.js";
import { InlineStyles } from "./auth-service-tools234.js";
import { isNumberLike } from "./auth-service-tools174.js";
import { useMantineSxTransform } from "./auth-service-tools199.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { getBoxMod } from "./auth-service-tools246.js";
import { getBoxStyle } from "./auth-service-tools247.js";
import { extractStyleProps } from "./auth-service-tools237.js";
import { STYlE_PROPS_DATA } from "./auth-service-tools238.js";
import { parseStyleProps } from "./auth-service-tools239.js";
import { useRandomClassName } from "./auth-service-tools242.js";

const _Box = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    component,
    style,
    __vars,
    className,
    variant,
    mod,
    size,
    hiddenFrom,
    visibleFrom,
    lightHidden,
    darkHidden,
    renderRoot,
    __size,
    ...others
  } = _ref;

  var _a;

  const theme = useMantineTheme();
  const Element = component || "div";
  const {
    styleProps,
    rest
  } = extractStyleProps(others);
  const useSxTransform = useMantineSxTransform();
  const transformedSx = (_a = useSxTransform == null ? void 0 : useSxTransform()) == null ? void 0 : _a(styleProps.sx);
  const responsiveClassName = useRandomClassName();
  const parsedStyleProps = parseStyleProps({
    styleProps,
    theme,
    data: STYlE_PROPS_DATA
  });
  const props = {
    ref,
    style: getBoxStyle({
      theme,
      style,
      vars: __vars,
      styleProps: parsedStyleProps.inlineStyles
    }),
    className: clsx(className, transformedSx, {
      [responsiveClassName]: parsedStyleProps.hasResponsiveStyles,
      "mantine-light-hidden": lightHidden,
      "mantine-dark-hidden": darkHidden,
      [`mantine-hidden-from-${hiddenFrom}`]: hiddenFrom,
      [`mantine-visible-from-${visibleFrom}`]: visibleFrom
    }),
    "data-variant": variant,
    "data-size": isNumberLike(size) ? void 0 : size || void 0,
    size: __size,
    ...getBoxMod(mod),
    ...rest
  };
  return /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */jsxRuntimeExports.jsx(InlineStyles, {
      selector: `.${responsiveClassName}`,
      styles: parsedStyleProps.styles,
      media: parsedStyleProps.media
    }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */jsxRuntimeExports.jsx(Element, { ...props
    })]
  });
});

_Box.displayName = "@mantine/core/Box";
const Box = createPolymorphicComponent(_Box);
export { Box };